import type { ReactNode } from 'react'
import type { UseFormReturn } from 'react-hook-form'

import { MarkdownEditor } from '@/components/organisms/markdown-editor/markdown-editor.organism'
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'

import type { AgentNodeFormSchemaType } from '../agency-node-form.schema'

interface AgentNodePromptSectionProps {
  form: UseFormReturn<AgentNodeFormSchemaType>
  nodeId: string | null
}

export const AgentNodePromptSection = ({
  form,
  nodeId,
}: AgentNodePromptSectionProps): ReactNode => (
  <FormField
    control={form.control}
    name="systemPrompt"
    render={({ field }) => (
      <FormItem>
        <FormLabel>System Prompt</FormLabel>
        <FormControl>
          <MarkdownEditor
            key={nodeId ?? 'new'}
            initialValue={field.value}
            onChange={field.onChange}
            onBlur={() => field.onBlur()}
            placeholder="Enter the system prompt for this agent..."
            variant="full"
            toolbar="system-prompt"
            minHeight="300px"
            className="agent-node-system-prompt-editor"
          />
        </FormControl>
        <FormDescription>Instructions that define how this agent behaves</FormDescription>
        <FormMessage />
      </FormItem>
    )}
  />
)

AgentNodePromptSection.displayName = 'AgentNodePromptSection'
